import React, { Suspense } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

import { AuthProvider } from '../context/AuthContext';
import { LayoutProvider } from '../context/useLayoutContext';
import AuthLayout from '../layouts/AuthLayout';
import AdminLayout from '../layouts/AdminLayout';
import ProtectedRoute from '../components/ProtectedRoute';
import FallbackLoading from '../components/FallbackLoading';
import TokenExpiredModal from '../components/TokenExpiredModal';

import LoginPage from '../app/login/page';
import { adminRoutes } from './index';

/**
 * Root router component.
 * Centralises all route definitions so App.js stays thin.
 */
export default function Router() {
  return (
    <BrowserRouter>
      <LayoutProvider>
        <AuthProvider>
          <TokenExpiredModal />
          <Routes>
            {/* Default redirect */}
            <Route path="/" element={<Navigate to="/dashboard" replace />} />

            {/* Auth routes */}
            <Route
              path="/login"
              element={
                <AuthLayout>
                  <LoginPage />
                </AuthLayout>
              }
            />

            {/* Protected admin routes */}
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              {adminRoutes.map(({ path, element, children }) => {
                const wrapped = (
                  <Suspense fallback={<FallbackLoading />}>{element}</Suspense>
                );
                if (children?.length) {
                  return (
                    <Route key={path} path={path} element={wrapped}>
                      {children.map((child) => (
                        <Route
                          key={child.index ? `${path}-index` : child.path}
                          index={child.index}
                          path={child.index ? undefined : child.path}
                          element={
                            <Suspense fallback={<FallbackLoading />}>
                              {child.element}
                            </Suspense>
                          }
                        />
                      ))}
                    </Route>
                  );
                }
                return <Route key={path} path={path} element={wrapped} />;
              })}
            </Route>

            {/* Fallback */}
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </AuthProvider>
      </LayoutProvider>
    </BrowserRouter>
  );
}
